<template>
    <div>
        <el-table
            ref="toll-free-verification-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-toll-free-verification="true"
                        :show-customer-profile="true"
                        :show-incoming-number-column="true"
                    />
                </template>
            </el-table-column>

            <!-- Timestamps Column -->
            <el-table-column
                label="Timestamps"
                width="140"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Line Column -->
            <el-table-column
                label="Line"
                width="140"
            >
                <template v-slot="scope">
                    <LineColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Volume Column -->
            <el-table-column
                label="Message Volume"
                width="150"
            >
                <template v-slot="scope">
                    <span v-if="scope.row.message_volume">{{ scope.row.message_volume }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <!-- Status Column -->
            <el-table-column
                label="Status"
                prop="status"
                width="120"
            >
                <template v-slot="scope">
                    <StatusColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Failure Reason Column -->
            <el-table-column
                label="Failure reason"
                prop="rejection_reason"
            >
                <template v-slot="scope">
                    <FailureReasonColumn 
                        :row="getTollFreeRowForFailureReason(scope.row)" 
                        :is-toll-free-verification="true"
                    />
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Action"
                width="150"
            >
                <template v-slot="scope">
                    <div class="mt-1">
                        <el-button
                            type="primary"
                            size="mini"
                            class="btn-block"
                            @click="handleViewDetails(scope.row)"
                        >
                            See details
                        </el-button>
                    </div>
                    <div class="mt-1">
                        <el-button
                            type="danger"
                            size="mini"
                            class="btn-block"
                            @click="handleDeleteBundle(scope.row)"
                            :loading="loadingDeleteBundle.includes(scope.row.id)"
                        >
                            Delete
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import InformationColumn from '../columns/information-column'
import TimestampsColumn from '../columns/timestamps-column'
import LineColumn from '../columns/line-column'
import StatusColumn from '../columns/status-column'
import FailureReasonColumn from '../columns/failure-reason-column'
import { compliance_mixin } from '../../../mixins'

export default {
    name: 'TollFreeVerificationBundleTable',
    mixins: [compliance_mixin],
    components: {
        InformationColumn,
        TimestampsColumn,
        LineColumn,
        StatusColumn,
        FailureReasonColumn,
    },
    props: {
        bundles: {
            type: Array,
            required: true,
        },
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getTollFreeRowForFailureReason(originalRow) {
            // Transform toll-free verification row to match FailureReasonColumn expectations
            return {
                ...originalRow,
                // Keep both error_code and rejection_reason for toll-free verification handling
                error_code: originalRow.error_code,
                rejection_reason: originalRow.rejection_reason,
            }
        },
        handleViewDetails(bundle) {
            this.$emit('view-details', bundle)
        },
        handleDeleteBundle(bundle) {
            this.$emit('delete-bundle', bundle)
        },
    },
}
</script>
